import React, { useMemo } from "react";
import { Trans, useTranslation } from "react-i18next";
import PictureSetPictureList from "./PictureSetPictureList";
import { DividerWithText } from "@/react/Webshop/Mobile/Pages/MyPictureSet/Components/DividerWithText";
import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";
import Box from "@mui/material/Box";
import makeStyles from "@mui/styles/makeStyles";
const useStyles = makeStyles((theme) => ({
    favoritesTextContainer: {
        "& svg": {
            marginRight: theme.spacing(2),
        },
    },
}));
const PictureSetPictures = ({ pictureSet }) => {
    const [favorites, nonFavorites] = useMemo(() => {
        const favorites = pictureSet.pictures.filter((p) => p.isUserFavorite);
        const nonFavorites = pictureSet.pictures.filter((p) => !p.isUserFavorite);
        return [favorites, nonFavorites];
    }, [pictureSet]);
    const classes = useStyles();
    if (pictureSet.pictures.length === 0) {
        return React.createElement(NoImageReason, { pictureSet: pictureSet });
    }
    if (favorites.length === 0) {
        return (React.createElement(PictureSetPictureList, { pictures: nonFavorites, pictureSet: pictureSet }));
    }
    // We have favorites, so display them in two sections:
    return (React.createElement("div", null,
        React.createElement(DividerWithText, null,
            React.createElement(Box, { display: "flex", alignItems: "center", className: classes.favoritesTextContainer },
                React.createElement(FavoriteBorderIcon, null),
                " ",
                React.createElement(Trans, null, "Favorites"))),
        React.createElement(PictureSetPictureList, { pictures: favorites, pictureSet: pictureSet }),
        React.createElement(DividerWithText, null,
            React.createElement(Trans, null, "Non Favorites")),
        React.createElement(PictureSetPictureList, { pictures: nonFavorites, pictureSet: pictureSet })));
};
function NoImageReason({ pictureSet }) {
    const [t] = useTranslation();
    if (pictureSet.job.hasBeenInWebShop ||
        pictureSet.job.requireFineTunedPictures) {
        return (React.createElement("p", null, t("Your pictures are not yet available in the webhop. You will receive an email from us with information as soon as the pictures are ready!")));
    }
    // Unknown reason :/
    return (React.createElement("p", null,
        React.createElement(Trans, null, "No pictures currently available")));
}
export default PictureSetPictures;
